
import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from './pages/Login'; 
import AppLayout from './components/AppLayout';
import Devices from './pages/SP/Devices';
import Stores from './pages/SP/Stores';
import StoresGroups from './pages/SP/StoresGroups';
import DevicesGroups from './pages/SP/DevicesGroups';
import DeviceTypes from './pages/SP/DeviceTypes';
import { InfoProvider as SPInfoProvider } from './context/InfoContext';
import { Box } from '@mui/material';
import Home from './pages/User/Home';
import AppBarre from './components/AppBar'; // Rinominato per coerenza
import { Typography } from '@mui/material';

// Componente placeholder per la pagina dei Totem
const TotemPage = () => <Typography variant="h4">Pagina Contenuti Totem</Typography>;

function App() {
  const [admin, setAdmin] = React.useState(true); // Esempio: utente loggato come admin

  return (
    <SPInfoProvider>
      <Routes>
        <Route path="/" element={<Login onAdmin={setAdmin}/>} />
        
        {/* ROTTE ADMIN (la tua logica era quasi corretta, ma semplificata) */}
        {admin ? (
          <Route path="/sp/*" element={<AppLayout><AdminRoutes /></AppLayout>} />
        ) : null}

        {/* ROTTE UTENTE (questa è la struttura corretta) */}
        {/* <Route path="/dsmm/*" element={<AppBarre />}> */}
          <Route path="/dsmm/home" element={<Home />} />
          <Route path="/dsmm/totem" element={<TotemPage />} />
          {/* Default route for user */}
        {/* </Route> */}

      </Routes>
    </SPInfoProvider>
  );
}

// Helper per raggruppare le rotte admin
const AdminRoutes = () => (
  <Routes>
    <Route path="devices" element={<Devices />} />
    <Route path="stores" element={<Stores />} />
    <Route path="store-groups" element={<StoresGroups />} />
    <Route path="device-groups" element={<DevicesGroups />} />
    <Route path="device-types" element={<DeviceTypes />} />
  </Routes>
);

export default App;